unit Config;
{

/* Initial. */

}
interface

uses
  LanguageTermList, TermListGetRequest, TermListGetResponse;

function InitConfig(const Boolean_Init: Boolean): Boolean;

var
  String_MachineGuid: String;
  String_Server: String;
  String_UserName: String;
  String_Password: String;
  String_ClientKey: String;
  String_Secret: String;
  String_FTPServer: String;
  String_FTPUserName: String;
  String_FTPPassword: String;
  String_Language: String;
  Boolean_Config_Backup: Boolean;

implementation

function InitConfig(const Boolean_Init: Boolean): Boolean;
var
  Boolean_Ok: Boolean;
  Byte_Try: Byte;
begin
  //If Boolean_Init then LoadConfig;

  String_Server := 'http://81.169.166.63:9092';

  LanguageTermList_Language := TLanguageTermList.Create;

  Result := True;
end;

end.
